exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".original-price{margin-left:0;font-size:16px;color:#999}@media screen and (max-width:576px){.soproni_small_single_box{padding:0}.product-img-wrapper .soproni_small_single_box_img{margin-bottom:0;margin-top:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a71cc5c2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/pages/page/widgets/DiscountProductsWidget.vue
// module id = 83
// module chunks = 0 1 2